var _ref2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEditGreen = function SvgEditGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 35,
    height: 35,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2 || (_ref2 = React.createElement("g", null, React.createElement("title", null, "Layer 1"), React.createElement("path", {
    fill: "currentColor",
    d: "M5.60931,27.64459a15.43423,15.34333 0 1 1 7.15586,4.11743a15.44968,15.35869 0 0 1 -7.15586,-4.11743z"
  }), React.createElement("path", {
    fill: "white",
    d: "M8.85595,24.42306l3.09751,-1.02097l-2.13552,-2.1263l-0.96199,3.14727zM13.20611,22.77426l3.71283,-3.69131l2.69098,-2.68094l5.39044,-5.34728l-2.69407,-2.68537l-5.38419,5.35992l-2.69286,2.6777l-3.71867,3.69249l2.69554,2.67479z"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEditGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/editGreen.9e2a82b9.svg";
export { ForwardRef as ReactComponent };